import {ContainerVPN, ServerSelectorBtn} from "./ServerSelectorBtn";
import React, {useState} from "react";
import UserStore from "../../store/user-store";
import styled from "styled-components";
import {AnimatePresence, motion} from "framer-motion";
import {createPortal} from "react-dom";
import {useHaptic} from "../../Hooks/useHaptic";


const ExtContainerVPN = styled(ContainerVPN)`
    display: flex;
    gap: 10px;
    padding: 0 16px;
    align-items: center;
    justify-content: space-between;
    height: 56px;
`


export const Container = ({
                              setShowItemSelector,
                              children
                          }) => {
    const overlayVariants = {
        hidden: {opacity: 0},
        visible: {
            opacity: 0.5,
            transition: {
                duration: 0.25,
                ease: "easeOut"
            }
        },
        exit: {
            opacity: 0,
            transition: {
                duration: 0.2,
                ease: "easeIn"
            }
        }
    };
    const containerVariants = {
        hidden: {
            y: '100%',
            scale: 1.02,
            opacity: 0
        },
        visible: {
            y: 0,
            scale: 1,
            opacity: 1,
            transition: {
                duration: 0.5,
                ease: [0.22, 1, 0.36, 1]
            }
        },
        exit: {
            y: '100%',
            scale: 1.02,
            opacity: 0,
            transition: {
                duration: 0.3,
                ease: "easeOut"
            }
        }
    };

    return (
        <>

            <motion.div
                initial="hidden"
                animate="visible"
                exit="exit"
                variants={overlayVariants}
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    background: '#000',
                    zIndex: 99999,
                    willChange: 'opacity',
                    cursor: 'pointer',
                }}
                onClick={() => setShowItemSelector(false)}
            />
            <motion.div
                layoutId="selector"
                initial="hidden"
                animate="visible"
                exit="exit"
                variants={containerVariants}
                style={{
                    backgroundColor: "#16181A",
                    position: "absolute",
                    bottom: 0,
                    width: "100%",
                    // height: "50%",
                    padding: "0px 16px 20px 16px",
                    zIndex: 1000000,
                    borderRadius: "30px 30px 0px 0px",
                    fontFamily: 'VK Sans Display, sans-serif',
                    willChange: 'transform',
                    display: "flex",
                    flexDirection: "column",
                    transform: 'translateZ(0)',
                    backfaceVisibility: 'hidden',
                    perspective: 1000,
                    opacity: "1 !important"
                }}
            >
                {children}
            </motion.div>
        </>
    )

}

const ItemsSelector = (
    {
        items,
        title,
        activeItemId,
        setShowItemSelector

    }
) => {
    return (
        createPortal(
            <>
                <Container setShowItemSelector={setShowItemSelector}>
                    <div style={{
                        display: "flex",
                        padding: "22px 0px 22px 0px",
                        position: 'relative',
                        alignItems: "center",
                        justifyContent: "center",
                    }}>
                        <h1 style={{
                            fontSize: "24px",
                            lineHeight: "28px",
                            textAlign: "center",
                            margin: 0,
                        }}>{title}</h1>

                        <button style={{
                            position: "absolute",
                            right: 0,
                            padding: 15,
                            border: 'none',
                            borderRadius: "50%",
                            backgroundColor: "#2D2F31",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: 'pointer',
                        }} onClick={() => setShowItemSelector(false)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                                 fill="none">
                                <path fillRule="evenodd" clipRule="evenodd"
                                      d="M15.3332 2.39224L2.39199 15.3334L0.666504 13.6079L13.6077 0.666748L15.3332 2.39224Z"
                                      fill="white"/>
                                <path fillRule="evenodd" clipRule="evenodd"
                                      d="M13.6077 15.3334L0.666504 2.39224L2.39199 0.666748L15.3332 13.6079L13.6077 15.3334Z"
                                      fill="white"/>
                            </svg>
                        </button>
                    </div>
                    <div style={{
                        display: "flex",
                        flexDirection: 'column',
                        alignItems: "center",
                        borderRadius: 12,
                        border: "1px solid rgba(255, 255, 255, 0.15)",
                        overflow: "hidden",
                    }}>

                        {items.map((item, idx) =>

                            <div
                                style={{
                                    borderBottom: item.id !== activeItemId && idx !== items.length - 1 ? "1px solid rgba(255, 255, 255, 0.15)" : "none",
                                    // border: item.id === activeItemId ? "1px solid #4D4E50" : "1px solid rgba(255, 255, 255, 0.15)",
                                    width: "100%",
                                    padding: 16,
                                    fontSize: 16,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    gap: 10,
                                    backgroundColor: item.id === activeItemId ? "#2D2F31" : "transparent",
                                    opacity: item.isSoon ? 0.5 : 1,
                                    cursor: !item.isSoon ? "pointer" : "help",

                                }}
                                onClick={() => {
                                    if (!item.isSoon) {
                                        item.setActiveItem()
                                        setShowItemSelector(false)
                                    }
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 10
                                    }}
                                >
                                    {item.icon && item.icon}
                                    <div>
                                        <p>{item.title}</p>
                                        <p style={{fontSize: 12, opacity: 0.7}}>{item.description}</p>
                                    </div>
                                </div>
                                {item.id === activeItemId &&
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                         fill="none">
                                        <path
                                            d="M9.54994 15.15L18.0249 6.675C18.2249 6.475 18.4583 6.375 18.7249 6.375C18.9916 6.375 19.2249 6.475 19.4249 6.675C19.6249 6.875 19.7249 7.11267 19.7249 7.388C19.7249 7.66333 19.6249 7.90067 19.4249 8.1L10.2499 17.3C10.0499 17.5 9.8166 17.6 9.54994 17.6C9.28327 17.6 9.04994 17.5 8.84994 17.3L4.54994 13C4.34994 12.8 4.25394 12.5627 4.26194 12.288C4.26994 12.0133 4.37427 11.7757 4.57494 11.575C4.7756 11.3743 5.01327 11.2743 5.28794 11.275C5.5626 11.2757 5.79994 11.3757 5.99994 11.575L9.54994 15.15Z"
                                            fill="#E6E6E6"/>
                                    </svg>}
                                {item.isSoon &&
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                         fill="none">
                                        <path
                                            d="M12 20C9.87827 20 7.84344 19.1572 6.34315 17.6569C4.84286 16.1566 4 14.1217 4 12H2C2 17.523 6.47701 22 12 22V20ZM12 4.00001C14.1217 4.00001 16.1566 4.84286 17.6569 6.34315C19.1572 7.84344 20 9.87828 20 12H22C22 6.47701 17.523 2.00001 12 2.00001V4.00001ZM4 12C3.99833 10.9492 4.20447 9.90838 4.60658 8.93753C5.00869 7.96667 5.59881 7.08492 6.343 6.34301L4.93 4.93001C4.00014 5.85727 3.26263 6.9591 2.75981 8.17221C2.25699 9.38533 1.99878 10.6858 2 11.999L4 12ZM6.343 6.34301C7.08492 5.59882 7.96667 5.00869 8.93753 4.60658C9.90838 4.20448 10.9492 3.99833 12 4.00001V2.00001C10.6865 1.99839 9.38572 2.25631 8.17225 2.75897C6.95878 3.26162 5.85659 3.99909 4.929 4.92901L6.343 6.34301ZM4.929 6.34301L17.657 19.071L19.071 17.657L6.343 4.92901L4.929 6.34301ZM20 12C20.0017 13.0508 19.7955 14.0916 19.3934 15.0625C18.9913 16.0333 18.4012 16.9151 17.657 17.657L19.071 19.071C20.0009 18.1434 20.7384 17.0412 21.241 15.8278C21.7437 14.6143 22.0016 13.3135 22 12H20ZM17.657 17.657C16.9151 18.4012 16.0333 18.9913 15.0625 19.3934C14.0916 19.7955 13.0508 20.0017 12 20V22C13.3135 22.0016 14.6143 21.7437 15.8278 21.2411C17.0412 20.7384 18.1434 20.0009 19.071 19.071L17.657 17.657Z"
                                            fill="white"/>
                                    </svg>}

                            </div>
                        )}
                    </div>
                </Container>

            </>
            , document.body
        )

    )
}

export const VpnSettingsSelector = (
    {
        title,
        bottomSheetTitle,
        items,
        activeItemId,
    }
) => {
    const [showItemSelector, setShowItemSelector] = useState(false);

    const isRu = UserStore.langCode === 'ru'
    const activeItem = items.find(item => item.id === activeItemId);
    const mainTitle = (isRu ? "Выберите " : "Chose ") + title;
    const {hapticFeedBack} = useHaptic("select")

    return (
        <div style={{}}>
            <h4 style={{
                marginBottom: 12,
                fontSize: 16,
                fontWeight: 400,
            }}>{mainTitle}</h4>
            <ExtContainerVPN onClick={() => {
                setShowItemSelector(!showItemSelector)
                hapticFeedBack()
            }}>
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    cursor: "pointer",
                }}>
                    {activeItem.icon && activeItem.icon}
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        <p style={{
                            fontSize: 16,
                        }}>{activeItem.title}</p>
                    </div>
                </div>
                {showItemSelector ?
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd"
                              d="M1.83594 13.0873L3.16176 14.4131L9.99885 7.57603L16.8359 14.4131L18.1618 13.0873L9.99885 4.92432L1.83594 13.0873Z"
                              fill="white" fillOpacity="0.3"/>
                    </svg>
                    :
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd"
                              d="M1.83594 6.91274L3.16176 5.58691L9.99885 12.424L16.8359 5.58691L18.1618 6.91274L9.99885 15.0757L1.83594 6.91274Z"
                              fill="white" fillOpacity="0.3">

                        </path>
                    </svg>}
            </ExtContainerVPN>
            <AnimatePresence>
                {showItemSelector &&
                    <ItemsSelector
                        items={items}
                        title={`${isRu ? "Выбор" : "Select"} ${bottomSheetTitle}`}
                        activeItemId={activeItemId}
                        setShowItemSelector={setShowItemSelector}
                    />}
            </AnimatePresence>
        </div>
    )
}